import React from 'react';
import { Image, Typography } from 'antd';

const { Title } = Typography;

const CInicioCliente = () => {
  return (
    <div
      style={{
        height: 'calc(80vh - 20px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        margin: '0',
      }}
    >
      <Image
        src="/logo-genosoftware.png"
        alt="Logo"
        preview={false}
        style={{ width: '50%', height: 'auto' }}
      />
    </div>
  );
};

export default CInicioCliente;
